import type { Dictionary } from '../types'

export const tr: Dictionary = {
  auth: {
    login: {
      title: 'Tekrar hoş geldiniz',
      subtitle: 'Mağaza yönetim paneline yönetici hesabınızla giriş yapın.',
      emailOrUsername: 'E-posta veya kullanıcı adı',
      emailPlaceholder: 'ornek@firma.com',
      emailRequired: 'E-posta veya kullanıcı adı gerekli',
      password: 'Şifre',
      passwordRequired: 'Şifre gerekli',
      showPassword: 'Şifreyi göster',
      hidePassword: 'Şifreyi gizle',
      submit: 'Giriş yap',
      submitting: 'Giriş yapılıyor…',
      welcome: 'Hoş geldiniz',
      unexpectedResponse: 'Giriş yanıtı beklenmedik',
      invalidCredentials: 'Kullanıcı adı veya şifre hatalı.',
      captchaRequired: '"Ben robot değilim" kutusunu işaretleyin.',
      failed: 'Giriş başarısız',
    },
    platform: {
      title: 'Platform erişimi',
      logging: 'Yönetim paneline giriş yapılıyor…',
      invalidLink: 'Geçersiz erişim bağlantısı.',
      loginFailed: 'Oturum açılamadı.',
      noAccess: 'Hedef hesap yönetim paneline erişemez.',
      expired: 'Bağlantı geçersiz veya süresi dolmuş.',
    },
  },
}

export const en: Dictionary = {
  auth: {
    login: {
      title: 'Welcome back',
      subtitle: 'Sign in to the store management panel with your admin account.',
      emailOrUsername: 'Email or username',
      emailPlaceholder: 'example@company.com',
      emailRequired: 'Email or username is required',
      password: 'Password',
      passwordRequired: 'Password is required',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      submit: 'Sign in',
      submitting: 'Signing in…',
      welcome: 'Welcome',
      unexpectedResponse: 'Unexpected login response',
      invalidCredentials: 'Username or password is incorrect.',
      captchaRequired: 'Please check the "I am not a robot" box to continue.',
      failed: 'Sign-in failed',
    },
    platform: {
      title: 'Platform access',
      logging: 'Signing in to management panel…',
      invalidLink: 'Invalid access link.',
      loginFailed: 'Could not open session.',
      noAccess: 'Target account cannot access the management panel.',
      expired: 'Link is invalid or has expired.',
    },
  },
}
